import { all } from 'axios';
import React, {useState} from 'react';
import { Accordion } from 'react-bootstrap';
import { AddCommasToAmount } from '../../../../helper/Utils';

const BudgetAllocationOverlay = ({ 
    overlay,
    setOverlay,
    overlayDropDown,
    setOverlayDropDown,
    toggleAccordion,
    bodyRef,
    activeKeys,
    activeCard,
    setActiveCard,
    allocationDetails,
    fy_list
}) => {
  const formatAmount = (value) => {
    if (value === null || value === undefined || value === '') return '-';
    return AddCommasToAmount(value);
  };
    const [departments, setDepartments] = useState([]);

    const mainCardSwitch = (val1, val2, val3, detailObj) => {
        setActiveCard((prev) => {
        let updated = [...prev];
        // Remove val2 and val3 if present
        updated = updated.filter(item => item !== val2 && item !== val3);
        // Add val1 if not already present
        if (!updated.includes(val1)) {
            updated.unshift(val1); // Add at the beginning
        }
        return updated;
        });
    };

    const getFinancialYear = (fyId) => {
        if(!fyId) return "N/A";
        const record = fy_list.find((fy) => Number(fy.id) === Number(fyId));
        return record.start_year + "-" + record.end_year;
    }

    const addOrRemoveDepartment = (department) => {
        setDepartments((prev) => {
            if (prev.includes(department)) {
                return prev.filter((dept) => dept !== department);
            } else {
                return [...prev, department];
            }
        });
    }

    function groupActivities(activityList) {
        const activityMap = new Map();

        activityList.forEach(item => {
            const actId = item.subhead_activity_id;

            if (!activityMap.has(actId)) {
            activityMap.set(actId, {
                subhead_activity_id: actId,
                activity: item.activity,
                budget: 0,
                provisional_budget: 0,
                subactivitiesMap: new Map()
            });
            }

            const act = activityMap.get(actId);
            act.budget += parseFloat(item.budget || 0);
            act.provisional_budget += parseFloat(item.provisional_budget || 0);

            const subactId = item.subhead_subactivity_id;
            if (subactId) {
            if (!act.subactivitiesMap.has(subactId)) {
                act.subactivitiesMap.set(subactId, {
                subhead_subactivity_id: subactId,
                subactivity: item.subactivity,
                budget: 0,
                provisional_budget: 0
                });
            }

            const sub = act.subactivitiesMap.get(subactId);
            sub.budget += parseFloat(item.budget || 0);
            sub.provisional_budget += parseFloat(item.provisional_budget || 0);
            }
        });

        // Convert to final output
        return Array.from(activityMap.values()).map(act => ({
            subhead_activity_id: act.subhead_activity_id,
            activity: act.activity,
            budget: act.budget,
            provisional_budget: act.provisional_budget,
            subactivities: Array.from(act.subactivitiesMap.values())
        }));
    }

  return (
    <div
        className={`overlayContent overflow-auto overflow-x-hidden ${
          overlay ? "left-100" : null
        } `}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="bg-secondary-100 position-relative text-white d-flex justify-content-between align-items-center ps-4">
          <div className="fw-600 fs-16px d-flex align-items-center gap-2 ">
            <i
              className="icon-close_circle_fill fs-5  cursor-pointer"
              onClick={() => setOverlay(true)}
            ></i>
            Child Allocation
          </div>

          <div className="d-flex gap-2 align-items-center h-100 py-3 position-relative pe-4">
            <i
              className="icon-arrow_drop_down_circle fs-18px cursor-pointer"
              onClick={() => setOverlayDropDown((prev) => !prev)}
            ></i>

            <div
              className={`position-absolute bg-prime-100 p-2 px-4 ${
                !overlayDropDown ? "d-none" : "d-inline-block"
              }`}
              style={{ top: "100%", right: "0%", zIndex: "10", width: "200px" }}
            >
              <div className="d-flex flex-column gap-4">
                <span className="d-flex align-items-center gap-2 cursor-pointer">
                  <i className="icon-picture_as_pdf"></i> Export PDF
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="px-4 py-3 d-flex flex-column gap-2">
          {/* ======================card view=========================== */}

          <div className="bg-white border-prime-20">
            {/* ================================card body========================= */}

            <div className="row p-2 m-0">
              <div className="col-4 px-1 mt-2">
                <span className="d-flex flex-column gap-1 p-0 px-1">
                  <label htmlFor="text" className="fs-12px text-black-60">
                    Budget Order No.
                  </label>
                  <span className="fs-14px fw-500">{allocationDetails?.budget_order_no}</span>
                </span>
              </div>
              <div className="col-4 px-1 mt-2">
                <span className="d-flex flex-column p-0 px-1 gap-1">
                  <label htmlFor="text" className="fs-12px text-black-60">
                    Budget Order Date.
                  </label>
                  <span className="fs-14px fw-500">{allocationDetails?.budget_order_date}</span>
                </span>
              </div>
              <div className="col-4 px-1 mt-2 d-flex align-items-center">
                <span className="d-flex align-items-center gap-2 p-0 px-1">
                    {
                        allocationDetails?.budget_order_doc_url &&
                        <a href={allocationDetails?.budget_order_doc_url} target="_blank" style={{color: 'black'}}><i className="icon-picture_as_pdf fs-18px"></i></a>
                        
                    }
                    {
                        allocationDetails?.budget_supporting_doc_url &&
                        <a href={allocationDetails?.budget_supporting_doc_url} target="_blank" style={{color: 'black'}}><i className="icon-picture_as_pdf fs-18px"></i></a>
                        
                    }
                </span>
              </div>
            </div>

            <div className="bg-prime-20 px-2 py-1 fw-600 fs-16px">
              Scheme Detail
            </div>

            <div className="row m-0 p-2">
              <div className="col-3 px-1 ">
                <span className="d-flex flex-column gap-1 p-0 px-1">
                  <label htmlFor="text" className="fs-12px text-black-60">
                    Scheme Code*:
                  </label>
                  <span className="fs-14px fw-500">{allocationDetails?.code}</span>
                </span>
              </div>
              <div className="col-3 px-1">
                <span className="d-flex flex-column gap-1 p-0 px-1">
                  <label htmlFor="text" className="fs-12px text-black-60">
                    Department Name
                  </label>
                  <span className="fs-14px fw-500">{allocationDetails?.department}</span>
                </span>
              </div>
              <div className="col-3 px-1">
                <span className="d-flex flex-column gap-1 p-0 px-1">
                  <label htmlFor="text" className="fs-12px text-black-60">
                    Type Of Scheme
                  </label>
                  <span className="fs-14px fw-500">{allocationDetails?.scheme_type}</span>
                </span>
              </div>
              <div className="col-3 px-1">
                <span className="d-flex flex-column gap-1 p-0 px-1">
                  <label htmlFor="text" className="fs-12px text-black-60">
                    FY
                  </label>
                  <span className="fs-14px fw-500">{getFinancialYear(allocationDetails?.financial_year_id)}</span>
                </span>
              </div>
            </div>
            <div className="row m-0 p-2">
              <div className="px-1 col-6">
                <span className="d-flex flex-column gap-1 p-0 px-1">
                  <label htmlFor="text" className="fs-12px text-black-60">
                    Scheme Name
                  </label>
                  <span className="fs-14px fw-500">{allocationDetails?.name}</span>
                </span>
              </div>
              <div className="px-1 col-3">
                <div className="m-0 p-0">
                  <p className="p-0 m-0 fs-12px text-black-60">Provisional</p>
                  <span className="text-black fs-14px fw-500">
                    {formatAmount(allocationDetails?.total_scheme_provisional_allocation)}
                  </span>
                </div>
              </div>
              <div className="px-1 col-3">
                <div className="m-0 p-0">
                  <p className="p-0 m-0 fs-12px text-black-60">Released</p>
                  <span className="text-success-100 fs-14px fw-500">
                    {formatAmount(allocationDetails?.total_scheme_released_allocation)}
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-prime-20 px-2 py-1 fw-600 fs-16px">
              Subhead Details
            </div>

            <div className="row px-2 py-1 m-0">
              <div className="col-3 fs-12px text-black-60">Subhead code</div>
              <div className="col-3 fs-12px text-black-60">subhead</div>
              <div className="col-3 fs-12px text-black-60">Provisional</div>
              <div className="col-3 fs-12px text-black-60">Released</div>
            </div>
            {
                allocationDetails?.budget_details?.map((subhead, index) => (
                    <div className="row px-2 py-1 m-0" key={index}>
                        <div className="col-3 fs-14px fw-500">{subhead.code}</div>
                        <div className="col-3 fs-14px fw-500">{subhead.name}</div>
                        <div className="col-3 fs-14px fw-500">{formatAmount(subhead.provisional_budget)}</div>
                        <div className="col-3 fs-14px text-success-100 fw-500">
                            {formatAmount(subhead.budget)}
                        </div>
                    </div>
                ))
            }
            <div className="row mx-2 py-1 m-0 bg-info-20">
              <div className="col-3 fs-14px fw-500">Total</div>
              <div className="col-3 fs-14px fw-500"></div>
              <div className="col-3 fs-14px fw-500">
                {formatAmount(
                  allocationDetails?.budget_details?.reduce(
                    (sum, s) => sum + Number(s?.provisional_budget ?? 0),
                    0
                  )
                )}
              </div>
              <div className="col-3 fs-14px text-success-100 fw-500">
                {formatAmount(
                  allocationDetails?.budget_details?.reduce(
                    (sum, s) => sum + Number(s?.budget ?? 0),
                    0
                  )
                )}
              </div>
            </div>

            <div className="bg-prime-20 py-1 m-0 mt-2 row align-items-center">
              <span className="fw-600 fs-16px col-lg-8 col-md-6">
                Allocation Details
              </span>
            </div>
            {
                allocationDetails?.budget_details?.map((budget, index) => (
                    <div className="px-3 pb-2 d-flex flex-column gap-1 mt-2">
                        <div className="accordion">
                            <div
                            className="header cursor-pointer fs-14px bg-secondary-20 fw-500 d-flex justify-content-between align-items-center p-1 px-2 "
                            onClick={() => addOrRemoveDepartment(budget?.department_id)}
                            >
                            <span>{budget?.department_level} | {budget?.department_code} | {budget?.department_name}</span>
                            <span>
                                <i
                                className={`icon-add_circle text-success-100 fs-16px ${
                                    departments.includes(budget?.department_id) ? "d-none" : ""
                                }`}
                                ></i>
                                <i
                                className={`icon-remove_circle text-success-100 fs-16px ${
                                    departments.includes(budget?.department_id) ? "" : "d-none"
                                }`}
                                ></i>
                            </span>
                            </div>

                            <div
                            className={`accbody p-2 ${departments.includes(budget?.department_id) ? "" : "d-none"}`}
                            ref={bodyRef}
                            style={{
                                height: "auto",
                                overflow: "hidden",
                                transition: "height 0.3s ease",
                            }}
                            >
                                <div>
                                    {/* ==============================subhead data================================ */}
                                    <div className="pb-2 d-flex justify-content-between text-secondary-50 px-4">
                                        <button
                                        onClick={() => mainCardSwitch(`subhead_2_${budget.scheme_id}`, `activity_2_${budget.scheme_id}`, `subactivity_2_${budget.scheme_id}`, {scheme_id: budget.scheme_id, subhead: true, activity: false, subActivity: false})}
                                        className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1 rounded-4 ${
                                            activeCard.includes(`subhead_2_${budget.scheme_id}`) ? "bg-secondary-20" : "bg-white"
                                        } `}
                                        >
                                        {activeCard.includes(`subhead_2_${budget.scheme_id}`) ? (
                                            <i className="icon-remove_circle_outline"></i>
                                        ) : (
                                            <i className="icon-add_circle_outline"></i>
                                        )}
                                        Sub head
                                        </button>
                                        <button
                                        onClick={() => mainCardSwitch(`activity_2_${budget.scheme_id}`,`subhead_2_${budget.scheme_id}`, `subactivity_2_${budget.scheme_id}`, {scheme_id: budget.scheme_id, subhead: false, activity: true, subActivity: false})}
                                        className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4 ${
                                            activeCard.includes(`activity_2_${budget.scheme_id}`) ? "bg-secondary-20" : "bg-white"
                                        } `}
                                        >
                                        {activeCard.includes(`activity_2_${budget.scheme_id}`) ? (
                                            <i className="icon-remove_circle_outline"></i>
                                        ) : (
                                            <i className="icon-add_circle_outline"></i>
                                        )}
                                        Activity
                                        </button>
                                        <button
                                        onClick={() => mainCardSwitch(`subactivity_2_${budget.scheme_id}`,`activity_2_${budget.scheme_id}`,`subhead_2_${budget.scheme_id}`, {scheme_id: budget.scheme_id, subhead: false, activity: false, subActivity: true})}
                                        className={` ${
                                            activeCard.includes(`subactivity_2_${budget.scheme_id}`) ? "bg-secondary-20" : "bg-white"
                                        } border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4`}>
                                        {activeCard.includes(`subactivity_2_${budget.scheme_id}`) ? (
                                            <i className="icon-remove_circle_outline"></i>
                                        ) : (
                                            <i className="icon-add_circle_outline"></i>
                                        )}
                                        Sub-Activity
                                        </button>
                                    </div>

                                    {activeCard.includes(`subhead_2_${budget.scheme_id}`) && (
                                    <>
                                        <hr className="m-0 my-1" />
                                        <div className="row">
                                        <div className="row">
                                            <div className="col-3 fs-12px text-black-60">
                                            Subhead code
                                            </div>
                                            <div className="col-3 fs-12px text-black-60">
                                            Subhead
                                            </div>
                                            <div className="col-3 fs-12px text-black-60">
                                            Provisional
                                            </div>
                                            <div className="col-3 fs-12px text-black-60">
                                            Released
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-3 fs-14px fw-500">{budget.code}</div>
                                            <div className="col-3 fs-14px fw-500">
                                            {budget.name}
                                            </div>
                                            <div className="col-3 fs-14px fw-500">
                                            {formatAmount(budget?.provisional_budget)}
                                            </div>
                                            <div className="col-3 fs-14px fw-500 text-success-100">
                                            {formatAmount(budget?.budget)}
                                            </div>
                                        </div>
                                        </div>
                                    </>
                                    )}
                                    {activeCard.includes(`activity_2_${budget.scheme_id}`) && (
                                    <Accordion style={{ border: "0" }}>
                                        <Accordion.Item
                                        eventKey={`${budget.id}`}
                                        style={{ borderRadius: "0", border: "0" }}
                                        >
                                        <Accordion.Header
                                            onClick={() => toggleAccordion(`${budget.id}`)}
                                        >
                                            <div className="w-100 d-flex justify-content-between">
                                            <span>{budget.code} | {budget.name}</span>
                                            <span
                                                className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                                style={{
                                                height: "13.33px",
                                                width: "13.33px",
                                                }}
                                            >
                                                {activeKeys.includes(`${budget.id}`) ? "-" : "+"}
                                            </span>
                                            </div>
                                        </Accordion.Header>

                                        <Accordion.Body>
                                            <div className="py-1">
                                            {/* ==============================subhead data================================ */}

                                            <div className="m-0 p-0">
                                                <div className="row p-0 m-0">
                                                    <div className="col fs-12px text-black-60">
                                                        Activity
                                                    </div>
                                                    <div className="col fs-12px text-black-60">
                                                        Provisional FY {getFinancialYear(allocationDetails?.financial_year_id)}
                                                    </div>
                                                    <div className="col fs-12px text-black-60">
                                                        Released FY {getFinancialYear(allocationDetails?.financial_year_id)}
                                                    </div>
                                                </div>
                                                {
                                                    groupActivities(budget.activities)?.map((activity, index) => (
                                                        <div className="row p-1 m-0">
                                                            <div className="col fs-14px fw-500">{activity?.activity}</div>
                                                            <div className="col fs-14px fw-500">
                                                                {formatAmount(activity?.provisional_budget)}
                                                            </div>
                                                            <div className="col fs-14px fw-500">
                                                                {formatAmount(activity?.budget)}
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                                

                                                <div className="row p-1 m-0 bg-info-20 ">
                                                    <div className="col fs-14px fw-500 text-prime-100">
                                                        Total
                                                    </div>
                                                    <div className="col fs-14px fw-500">
                                                        {formatAmount(budget?.provisional_budget)}
                                                    </div>
                                                    <div className="col fs-14px fw-500">
                                                        {formatAmount(budget?.budget)}
                                                    </div>
                                                </div>
                                            </div>
                                            </div>
                                        </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                    )}
                                    {activeCard.includes(`subactivity_2_${budget.scheme_id}`) && (
                                        <>
                                            {groupActivities(budget.activities)?.map((activity, index) => (
                                                <Accordion style={{ border: "0" }} key={index}>
                                                    <Accordion.Item
                                                    eventKey={`subactivity_2_${budget.id}_${activity.subhead_activity_id}`}
                                                    style={{ borderRadius: "0", border: "0" }}
                                                    >
                                                    <Accordion.Header
                                                        onClick={() => toggleAccordion(`subactivity_2_${budget.id}_${activity.subhead_activity_id}`)}
                                                    >
                                                        <div className="w-100 d-flex justify-content-between">
                                                        <span>{budget.code} | {activity?.activity}</span>
                                                        <span
                                                            className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                                                            style={{
                                                            height: "13.33px",
                                                            width: "13.33px",
                                                            }}
                                                        >
                                                            {activeKeys.includes(`subactivity_2_${budget.id}_${activity.subhead_activity_id}`) ? "-" : "+"}
                                                        </span>
                                                        </div>
                                                    </Accordion.Header>

                                                    <Accordion.Body>
                                                        <div className="py-1">
                                                        {/* ==============================subhead data================================ */}

                                                        <div className="m-0 p-0">
                                                            <div className="row p-0 m-0">
                                                                <div className="col fs-12px text-black-60">
                                                                    Sub-Activity
                                                                </div>
                                                                <div className="col fs-12px text-black-60">
                                                                    Provisional FY {getFinancialYear(allocationDetails?.financial_year_id)}
                                                                </div>
                                                                <div className="col fs-12px text-black-60">
                                                                    Released FY {getFinancialYear(allocationDetails?.financial_year_id)}
                                                                </div>
                                                            </div>
                                                            {
                                                                activity.subactivities?.map((subactivity, subIndex) => (
                                                                    <div className="row p-1 m-0" key={subIndex}>
                                                                        <div className="col fs-14px fw-500">{subactivity?.subactivity}</div>
                                                                        <div className="col fs-14px fw-500">
                                                                            {formatAmount(subactivity?.provisional_budget)}
                                                                        </div>
                                                                        <div className="col fs-14px fw-500">
                                                                            {formatAmount(subactivity?.budget)}
                                                                        </div>
                                                                    </div>
                                                                ))
                                                            }
                                                            <div className="row p-1 m-0 bg-info-20 ">
                                                                <div className="col fs-14px fw-500 text-prime-100">
                                                                    Total
                                                                </div>
                                                                <div className="col fs-14px fw-500">
                                                                    {formatAmount(
                                                                      activity?.subactivities?.reduce(
                                                                        (sum, sub) => sum + Number(sub?.provisional_budget ?? 0),
                                                                        0
                                                                      )
                                                                    )}
                                                                </div>
                                                                <div className="col fs-14px fw-500">
                                                                    {formatAmount(
                                                                      activity?.subactivities?.reduce(
                                                                        (sum, sub) => sum + Number(sub?.budget ?? 0),
                                                                        0
                                                                      )
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        </div>
                                                    </Accordion.Body>
                                                    </Accordion.Item>
                                                </Accordion>
                                            ))
                                        }

                                    </>
                                    )}
                                </div>
                            </div>
                        </div>
                        </div>
                ))
            }


            <div className="row m-0 p-2 my-2">
              <div className="col-12">
                <div className="row">
                  <div className="col-4 m-0 p-0">
                    <div className="m-0 p-0">
                        <span className="fs-12px text-prime-100 p-0 m-0">L1 Remark</span>
                        <p style={{fontSize: '12px'}}>{allocationDetails?.l1_remark}</p>
                    </div>
                  </div>
                  <div className="col-4 m-0 p-0">
                    <div className="m-0 p-0">
                        <span className="fs-12px text-prime-100 p-0 m-0">L2 Remark</span>
                        <p style={{fontSize: '12px'}}>{allocationDetails?.l2_remark}</p>
                    </div>
                  </div>
                  <div className="col-4 m-0 p-0">
                    <div className="m-0 p-0">
                        <span className="fs-12px text-prime-100 p-0 m-0">L3 Remark</span>
                        <p style={{fontSize: '12px'}}>{allocationDetails?.l3_remark}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
  );
};


export default BudgetAllocationOverlay;